module.exports = __webpack_public_path__ + "static/media/schody31 - schody drewniane zabiegowe.2d8a41b5.jpg";